import Vue from "vue";
import Vuex from "vuex";
import router from "../router";
import api from "../api";
import createPersistedState from "vuex-persistedstate";
import harcodedConfigValues from "./harcodedConfigValues";

Vue.use(Vuex);

export default new Vuex.Store({
    plugins: [
        createPersistedState({
            key: "storev1"
        })
    ],

    state: {
        // Note: All this state must be moved to modules eventually
        _ga: null,
        lang: "es",
        config: null,
        region: null,
        regionLockContactSent: false,
        // livetrial: [],
        // endtrial: 0,
        series: [],
        categories: [],
        games: [],
        homeData: null,
        freeContent: [],

        // user registration
        selectedPlanForRegistration: "MONTH",
        userRegistrationData: {
            name: "",
            email: ""
        },

        // user
        authenticatedUser: null,
        authenticatedUserAccess: null,

        // player
        player: {
            videos: [],
            currentVideo: 0
        },

        // content pages
        contentPages: [],

        //live
        live: [
            {
                app_banner: null,
                app_free_url: null,
                free_url: null,
                id: "0",
                img: null,
                poster: null,
                poster_cast: null,
                programming: [],
                timer: 0,
                title: "FlixKids Live",
                type: "kids",
                url: null,
                web_img: null
            }
        ]
    },

    mutations: {
        ["SET_LANG"](state, lang) {
            state.lang = lang;
        },

        ["SET_CONFIG"](state, configValues) {
            let formattedConfigValues = harcodedConfigValues(state.lang);

            configValues.forEach(
                configVal =>
                    (formattedConfigValues[configVal.parametro] =
                        configVal.valor)
            );

            state.config = formattedConfigValues;
        },

        ["SET_REGION"](state, region) {
            // if (process.env.NODE_ENV == "development") {
            //     state.region = {
            //         status: "true",
            //         data: {
            //             code: "us"
            //         }
            //     };
            //
            //     return;
            // }

            state.region = region;
        },

        ["SET_REGION_LOCK_CONTACT_SENT"](state) {
            state.regionLockContactSent = true;
        },

        ["SET_SERIES"](state, series) {
            state.series = series;
        },

        ["SET_LIVE"](state, live) {
            state.live = live;
        },

        ["SET_CATEGORIES"](state, categories) {
            state.categories = categories;
        },

        ["SET_GAMES"](state, games) {
            state.games = games;
        },

        ["SET_HOME_DATA"](state, homeData) {
            state.homeData = homeData;
        },

        ["SET_FREE_CONTENT"](state, freeContent) {
            state.freeContent = freeContent;
        },

        ["SET_SELECTED_PLAN"](state, plan) {
            state.selectedPlanForRegistration = plan;
        },

        ["SET_USER_REGISTRATION_NAME"](state, name) {
            state.userRegistrationData.name = name;
        },

        ["SET_USER_REGISTRATION_EMAIL"](state, email) {
            state.userRegistrationData.email = email;
        },

        ["SET_AUTHENTICATED_USER"](state, user) {
            state.authenticatedUser = user;
        },

        ["SET_AUTHENTICATED_USER_ACCESS"](state, access) {
            state.authenticatedUserAccess = access;
        },

        ["SET_PLAYER_VIDEOS"](state, videos) {
            state.player.videos = videos;
        },

        ["SET_PLAYER_CURRENT_VIDEO"](state, currentVideo) {
            state.player.currentVideo = currentVideo;
        },

        ["SET_CONTENT_PAGES"](state, contentPages) {
            state.contentPages = contentPages;
        },
        ["SET_GA"](state, ga) {
            state._ga = ga;
        }
    },
    actions: {
        async ["SAVE_GA"]({ commit }, ga) {
            console.log("nGA", ga);
            commit("SET_GA", ga);
        },
        async ["FETCH_CONFIG"]({ commit }) {
            let config = await api.fetchConfig();

            commit("SET_REGION", config.region);
            commit("SET_CONFIG", config.configValues);
        },

        async ["TOGGLE_LANG"](context) {
            context.commit("SET_LANG", context.getters.toggleToLang);

            window.location.reload();
        },

        async ["FETCH_SERIES"]({ commit }) {
            let series = await api.fetchSeries();

            commit("SET_SERIES", series);
        },

        async ["FETCH_CATEGORIES"]({ commit }) {
            let categories = await api.fetchCategories();

            commit("SET_CATEGORIES", categories);
        },

        async ["FETCH_GAMES"]({ commit }) {
            let games = await api.fetchGames();

            commit("SET_GAMES", games);
        },

        ["SIGN_OUT"]({ commit, dispatch }) {
            commit("SET_AUTHENTICATED_USER", null);
            commit("SET_AUTHENTICATED_USER_ACCESS", null);

            dispatch("RESET_PLAYER");
        },

        async ["FETCH_LIVE"]({ commit }) {
            let data = await api.fetchLiveData();
            commit("SET_LIVE", data);
        },

        async ["liveRegPos"](context, params) {
            let options = {
                livechannel: params.id,
                type: "live",
                second: params.time
            };

            api.regPosLive(options);
        },

        async ["FETCH_INITIAL_DATA"]({ commit }) {
            let data = await api.fetchInitialData();

            commit("SET_LIVE", data.live);
            commit("SET_SERIES", data.series);
            commit("SET_CATEGORIES", data.categories);
            commit("SET_HOME_DATA", data.home_hero);
            commit("SET_FREE_CONTENT", data.free);
            commit("SET_GAMES", data.games);
        },

        async ["FETCH_SERIES_CATEGORIES_GAMES"]({ commit }) {
            let seriesCategoriesGames = await api.fetchSeriesCategoriesGames();

            commit("SET_SERIES_CATEGORIES_GAMES", seriesCategoriesGames);
        },

        ["OPEN_PLAYER"]({ commit }, { videos, currentVideo }) {
            commit(
                "SET_PLAYER_VIDEOS",
                videos.filter(video => {
                    return !video.locked && video.url;
                })
            );

            commit("SET_PLAYER_CURRENT_VIDEO", currentVideo || 0);

            router.push({ name: "player" });
        },

        ["RESET_PLAYER"]({ commit }) {
            commit("SET_PLAYER_VIDEOS", []);
            commit("SET_PLAYER_CURRENT_VIDEO", 0);
        },

        async ["FETCH_CONTENT_PAGES"]({ commit }) {
            let contentPages = await api.fetchContentPages();

            commit("SET_CONTENT_PAGES", contentPages);
        }
    },

    getters: {
        getGa: state => {
            return state._ga;
        },
        getConfigValue: state => key => {
            if (state.config && state.config[key]) {
                return state.config[key];
            }

            return "";
        },

        toggleToLang: state => {
            return state.lang == "es" ? "en" : "es";
        },

        selectedPlanSubscriptionCode: (state, getters) => {
            return state.selectedPlanForRegistration == "MONTH"
                ? getters.getConfigValue("MONTH_PLAN")
                : getters.getConfigValue("YEAR_PLAN");
        },

        selectedPlanPrice: (state, getters) => {
            return state.selectedPlanForRegistration == "MONTH"
                ? getters.getConfigValue("MONTH_PRICE")
                : getters.getConfigValue("YEAR_PRICE");
        },

        selectedPlanCycle: (state, getters) => {
            return state.selectedPlanForRegistration == "MONTH"
                ? getters.getConfigValue("MES")
                : getters.getConfigValue("ANO");
        },

        userToken: state => {
            let user = state.authenticatedUser;

            if (user && user.token) {
                return user.token;
            }

            return null;
        },

        userSubscriptionIsActive: state => {
            let user = state.authenticatedUser;

            return user.payment_status && user.payment_status != "cancelled";
        },

        userSubscriptionIsCancelled: state => {
            let user = state.authenticatedUser;

            return user.payment_status && user.payment_status == "cancelled";
        },

        userCanApplyPromocode: (state, getters) => {
            let user = state.authenticatedUser;

            return (
                getters.userSubscriptionIsActive && user.gateway == "braintree"
            );
        },

        registerOrHomeRoute: state => {
            if (!state.authenticatedUser) {
                return { name: "register-sign-up" };
            } else if (
                state.authenticatedUser &&
                state.authenticatedUserAccess &&
                state.authenticatedUserAccess != "full"
            ) {
                return { name: "register-payment" };
            }

            return { name: "home" };
        },

        getLiveChannels: state => {
            return state.live;
        },

        getContentPage: state => pageName => {
            return state.contentPages.find(
                contentPage => contentPage.name == pageName
            );
        }
    },
    modules: {}
});
